import React, { useState } from "react";
import { Loading, ModalContent } from "../../../../common";

import { url } from "../../../../config";

//vymaz maaaaa
import L from "leaflet";

const axios = require("axios").default;

export default function GeneralFunctions() {
    let [modalConfig, setModalConfig] = useState({ show: false });

    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Pracujem");

    //či sa pri prepočte odznakov majú posielať upozornenia
    const [notifyAchievements, setNotifyAchievements] = useState(false);

    const [activities, setActivities] = useState([
        {
            name: 'DELETE_WITH_DELETED_KUZEL',
            label: 'Odstrániť notifikácie, ktoré odkazujú na neexistujúci kužeľ',
            endpoint: '/private/rest/admin/clean-up/notification/with-deleted-kuzel'
        },
        {
            name: 'REPLACE_KUZELNIK_NAME_FOR_NICKNAME',
            label: 'Nahradiť meno v notifikáciach za prezývku',
            endpoint: '/private/rest/admin/clean-up/notification/replace-name'
        },
        {
            name: 'UPDATE_NOTIFICATION_KUZEL_PHOTO',
            label: 'Aktualizovať fotku kužela v notifikáciach, pri ktorých sa zmenila',
            endpoint: '/private/rest/admin/clean-up/notification/photo-update'
        },
        {
            name: 'UPDATE_NOTIFICATION_CITY_AND_COUNTRY',
            label: 'Aktualizovať mesto a štát v notifikáciach, pri ktorých boli zmenené',
            endpoint: '/private/rest/admin/clean-up/notification/city-country'
        },
    ]);

    const doActivityModal = (activity) => {
        setModalConfig({
            show: true,
            headerContent: null,
            bodyContent: <>
                <div className="text-center" style={{ fontSize: '15px' }}><b>Naozaj chceš vykonať: "{activity.label}" ? </b></div>
                {activity.note && (
                    <div className="text-center mt-2" style={{ fontSize: '14px' }}>{activity.note}</div>
                )}
            </>,
            footerContent: <>
                <button className="btn-kuzel" onClick={() => doActivity(activity)}>Áno</button>
                <button className="btn-kuzel secondary" onClick={() => setModalConfig({ show: false })}>Zrušiť</button>
            </>
        });
    }

    const doActivity = (activity) => {
        let responseMessage = "";

        setLoadingText(activity.loadingText ?? "Pracujem");
        setLoading(true);

        axios
            //cez request(), aby sa dala pouzit aj POST akcia - parametre chodia v query, nie v tele
            .request({ method: activity.method ?? 'get', url: url + activity.endpoint })
            .then((res) => {
                //cistiace akcie vracaju void, prepocet odznakov vracia SimpleResponse so spravou
                responseMessage = res.data?.message ?? "Hotovo";
            })
            .catch((err) => {
                if (err.response?.status === 403) {
                    responseMessage = `Na túto akciu nemáš právo${activity.permission ? ` (${activity.permission})` : ''}. Prideľ si ho v Rolách.`;
                } else {
                    responseMessage = err.response?.data?.message ?? "Nezdarilo sa";
                }
            })
            .then((res) => {
                setLoading(false);

                setModalConfig({
                    show: true,
                    headerContent: null,
                    bodyContent: <div className="text-center" style={{ fontSize: '15px' }}><b>{responseMessage}</b></div>,
                    footerContent: <button className="btn-kuzel secondary" onClick={() => setModalConfig({ show: false })}>Zrušiť</button>
                });
            })
    }

    const recomputeAchievementsActivity = () => ({
        name: 'RECOMPUTE_ACHIEVEMENTS',
        label: 'Prepočítať odznaky všetkým kužeľníkom',
        endpoint: `/private/rest/admin/achievement/recompute?notify=${notifyAchievements}`,
        method: 'post',
        permission: 'admin_achievement_manage',
        loadingText: "Prepočítavam",
        note: notifyAchievements
            ? 'Upozornenia sa POŠLÚ – každý kužeľník dostane upozornenie za každý novo priznaný odznak.'
            : 'Upozornenia sa neposielajú, odznaky sa len pridajú.'
    });

    //vymaz maaaaaaaa
    const spravTo = () => {
        var geocoder = L.Control.Geocoder.nominatim({ reverseQueryParams: { 'accept-language': 'en' } });

        axios
            .get(url + '/private/rest/admin/kuzel/all?page=0&size=18000')
            .then((res) => {
                var kokot = 0;
                for (let address of res.data.data) {
                    console.log(address);

                    setTimeout(function () {

                        geocoder.reverse(
                            { lat: address.lat, lng: address.lng },
                            67108864,
                            (results) => {
                                console.log(results);
                                var r = results[0].properties.address;
                                if (r) {
                                    var addressString = (r.country_code ?? '_').trim() + '-' + (address.city ?? '_').trim() + '-' + (r.county ?? '_').trim() + '-' + (r.region ?? '_').trim() + '-' + (r.state ?? '_').trim() + '-' + (r.province ?? '_').trim();

                                    axios
                                        .put(url + '/private/rest/admin/kuzel/address-id/' + address.id, { value: addressString })
                                        .then((res) => {

                                        })

                                    console.log(addressString);
                                }
                            }
                        );
                    }, kokot)

                    kokot = kokot + 5000;
                }
            })
            .catch((err) => {

            })
    }

    return (
        <>
            <h4 className="mt-2 mb-3">Notifikácie</h4>

            {
                activities.map((activity) => {
                    return (
                        <div className="mt-2" key={activity.name}>
                            <button className="btn-kuzel secondary opacityHover ms-1 mb-1" onClick={() => doActivityModal(activity)}>{activity.label}</button>
                        </div>
                    )
                })
            }

            {/*vymaz maaaaaaaa*/}
            <button className="btn-kuzel secondary opacityHover ms-1 my-2" onClick={() => spravTo()}>sprav to</button>

            <div className="szh-menu__divider my-3"></div>

            <h4 className="mt-2 mb-3">Odznaky</h4>

            <div className="ms-1" style={{ fontSize: '14px' }}>
                Prepočíta odznaky všetkým kužeľníkom a prizná tie, ktoré ešte nemajú. Treba to spustiť
                po každom pridaní nových odznakov – kužeľníkom, ktorí už kužele majú, sa inak nedopočítajú.
                Odznaky sa nikdy neodoberajú, takže opakované spustenie je bezpečné.
            </div>

            <div className="form-check ms-1 mt-3">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="notifyAchievements"
                    checked={notifyAchievements}
                    onChange={(e) => setNotifyAchievements(e.target.checked)} />
                <label className="form-check-label" htmlFor="notifyAchievements">
                    Poslať upozornenia o nových odznakoch
                </label>
            </div>

            {
                notifyAchievements && (
                    <div className="ms-1 mt-1" style={{ fontSize: '13px', color: '#c2160f' }}>
                        <b>Pozor:</b> vznikne upozornenie za <b>každý</b> novo priznaný odznak <b>každému</b> kužeľníkovi.
                        Po pridaní viacerých odznakov naraz to môžu byť tisíce upozornení a zaplnený zvonec u všetkých.
                    </div>
                )
            }

            <div className="mt-3">
                <button
                    className="btn-kuzel secondary opacityHover ms-1 mb-1"
                    onClick={() => doActivityModal(recomputeAchievementsActivity())}>
                    Prepočítať odznaky všetkým kužeľníkom
                </button>
            </div>

            <div className="szh-menu__divider my-3"></div>

            <ModalContent
                modalConfig={modalConfig}
                loading={loading}
                loadingText={loadingText}
                onClose={(e) => setModalConfig({ show: false })}></ModalContent>
        </>
    );
}